
import * as d3 from 'd3'
export default {
  methods: {

    draw_Legends() {

      let legendGroup = this.canvasForm
      .append('g')
      .attr('id', 'Legend')
      .attr('transform', `translate(${this.legends.x}, ${this.legends.y})`)
      .attr('font-family', 'roboto')

      let x_ = 0
      this.stage.forEach((d,i)=> {

        let item = legendGroup
        .append('g')
        .attr('id', `ITEM_${i}`)
        .attr('transform', `translate(${x_}, 0)`)

        item
        .append('rect')
        .attr('x', 0).attr('x', 0)
        .attr('width', 8).attr('height', 8)
        .attr('fill', d.color).attr('stroke', d.stroke ? d.stroke :'#bcbcbc').attr('stroke-width', d.sWidth ? d.sWidth : .5)

        item
        .append('text')
        .attr('transform', `translate(12, ${4 + this.legends.tSize*0.35})`)
        .style('font-size', this.legends.tSize).style('fill', '#333')
        .text(d.name)

        x_ += this.getNode(`#ITEM_${i}`) + 10
      })

    },

  }
}